import { render, staticRenderFns } from "./SuperImage.vue?vue&type=template&id=09afd86c&"
import script from "./SuperImage.vue?vue&type=script&lang=js&"
export * from "./SuperImage.vue?vue&type=script&lang=js&"
import style0 from "./SuperImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/melissaallen/fuzzco/pretendstore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('09afd86c', component.options)
    } else {
      api.reload('09afd86c', component.options)
    }
    module.hot.accept("./SuperImage.vue?vue&type=template&id=09afd86c&", function () {
      api.rerender('09afd86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SuperImage.vue"
export default component.exports